import { Card, CardBody, Text } from '@chakra-ui/react';
import React from 'react';

export const Empty: React.FC<{ children: any }> = ({ children }) => {
  return (
    <Card display="flex" justify="center" align="center">
      <CardBody>
        <Text>{children}</Text>
      </CardBody>
    </Card>
  );
};
